import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import Frame from '..';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IFrame, IScaleInfo } from '../frame.interface';
import { AdjustSmartArtFrameInfo } from './adjusted-info';
import { IAdjustedElementsAndProps, IGroupFrameProperty } from './index.interface';
import { enumerateSimilarGroup } from '../../group-operation/enumerate';

export default class SmartArtFrame extends Frame implements IGroupFrameProperty {
    private adjustSmartArtFrameInfo: AdjustSmartArtFrameInfo;
    private smartArtModel: ISmartArtModel;
    public constructor(model: ISmartArtModel) {
        super(model);
        this.smartArtModel = model;
    }

    public getAdjustedElementsAndProps(
        childModels = this.smartArtModel.selectionService?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.SMART_ART) ?? [],
        childModelsProps?: IFrame[],
    ): IAdjustedElementsAndProps[] {
        if (!this.adjustSmartArtFrameInfo) {
            this.adjustSmartArtFrameInfo = new AdjustSmartArtFrameInfo();
        }
        return this.adjustSmartArtFrameInfo.getAdjustedElementsAndProps(childModels, childModelsProps);
    }

    public clearTempInfosWithElement(element: IElementBaseModel) {
        enumerateSimilarGroup(element, (smartArtModel: ISmartArtModel) => {
            if (smartArtModel.groupChildFrameChangedByChildren) {
                smartArtModel.groupChildFrameChangedByChildren = null;
            }
        });
    }

    public getScaleRelativeToSlide(): IScaleInfo {
        const scale = {
            scaleX: this.smartArtModel.scaleX,
            scaleY: this.smartArtModel.scaleY,
        };
        enumerateSimilarGroup(this.smartArtModel, (smartArtModel: ISmartArtModel) => {
            scale.scaleX *= smartArtModel.scaleX;
            scale.scaleY *= smartArtModel.scaleY;
        });
        return scale;
    }
}
